import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux"
//ACRIONS

//UI
import { Table, Segment, Header, Button, Input, Message } from "semantic-ui-react";

import CircularProgress from "@material-ui/core/CircularProgress";
import "../../../styles/common.css";
import { scrollToTop } from "../../../resources/utils";
import { fetchYachts } from "../../../../redux/actions/catalogs/yacht/fetchYachts";
import { fetchHistoricalTipTopThunk } from "../../../../redux/slices/custom/reservations/cruise/historicalTipTop/historicalTipTop.slice";

export default function HistoricalTipTopList() {
  let actualDate = new Date().getFullYear();
  const { t } = useTranslation();
  const [cruiseCode, setCruiseCode] = useState("");
  const cruiseOperate = "operados";
  const [cruiseYear, setCruiseYear] = useState(
    localStorage.getItem("year_historical") !== null
      ? localStorage.getItem("year_historical")
      : actualDate.toString() - 1
  );
  const [cruiseYacht, setCruiseYacht] = useState(
    localStorage.getItem("yacht_historical") !== null
      ? localStorage.getItem("yacht_historical")
      : "all"
  );

  const { cruises, years, fetching, error } = useSelector((state) => state.historicalTipTop);
  const yachtState = useSelector((state) => state.yachtsReducer);

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchHistoricalTipTopThunk('', cruiseYacht, cruiseYear, actualDate));
    dispatch(fetchYachts());
    scrollToTop();
  }, [dispatch, actualDate, cruiseOperate, cruiseYear]);

  if (fetching) {
    return <CircularProgress />;
  }

  const handleSeachCruiseCode = () => {
    dispatch(fetchHistoricalTipTopThunk(cruiseCode, cruiseYacht, cruiseYear, actualDate));
  };

  const handleSearchCruiseYear = (event) => {
    setCruiseCode("");
    dispatch(fetchHistoricalTipTopThunk(cruiseCode, cruiseYacht, event, actualDate));
  };

  const handleSearchCruiseYacht = (event) => {
    setCruiseCode("");
    dispatch(fetchHistoricalTipTopThunk(cruiseCode, event, cruiseYear, actualDate));
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      handleSeachCruiseCode();
    }
  };

  return (
    <>
      {error ? (
        <Message negative content={t(error)} />
      ) : (
        ""
      )}
      <Segment className="flex items-center justify-between" >
        <div className="ui breadcrumb">
          <div className="active section">{t("historical_tiptop_path")} </div>
        </div>
        <Header as='h5' floated='right' className="flex items-center justify-end">
          <Input type="text" placeholder={t("cruise_code") + "..."} action>
            <input
              defaultValue={cruiseCode}
              onChange={(event) => setCruiseCode(event.target.value)}
              onKeyDown={handleKeyDown}
            />
            <Button
              type="submit"
              onClick={() => handleSeachCruiseCode()}
              icon="search"
              size="medium"
            />
          </Input>
          &nbsp;
          <select
            className="ui selection dropdown"
            style={{ padding: '3px 5px' }}
            aria-expanded="true"
            name="years"
            value={cruiseYear}
            onChange={(event) => {
              handleSearchCruiseYear(event.target.value);
              setCruiseYear(event.target.value);
              localStorage.setItem("year_historical", event.target.value);
            }}
          >
            {years.map((year) => (
              <option className="selected item" value={year.year}>
                {year.year}
              </option>
            ))}
          </select>
          &nbsp;

          <select name="yacht_id" className="ui selection dropdown" aria-expanded="true"
            style={{ padding: '3px 5px' }}
            defaultValue={cruiseYacht}
            onChange={(event) => {
              handleSearchCruiseYacht(event.target.value);
              setCruiseYacht(event.target.value);
              localStorage.setItem("yacht_historical", event.target.value);
            }}
          >
            <option value="all">{t("all")}</option>
            {yachtState.yachts.map((yacht) => (
              <option key={yacht.id} value={yacht.id}>{yacht.name}</option>
            ))}
          </select>
        </Header>

      </Segment>
      <Table color="blue" striped>
        <Table.Header align="center">
          <Table.Row>
            <Table.HeaderCell>{t("cruise_code")}
              <br></br><br></br>
            </Table.HeaderCell>
            <Table.HeaderCell>{t("cruise_yacht")}
              <br></br><br></br>
            </Table.HeaderCell>
            <Table.HeaderCell>{t("cruise_startDate")}
              <br></br><span className="text_date_format">(dd-mm-yyyy)</span>
            </Table.HeaderCell>
            <Table.HeaderCell>{t("cruise_endDate")}
              <br></br><span className="text_date_format">(dd-mm-yyyy)</span>
            </Table.HeaderCell>
            <Table.HeaderCell>{t("cruise_total")}<br></br><br></br></Table.HeaderCell>
            <Table.HeaderCell>{t("cruise_firstPart")}<br></br><br></br></Table.HeaderCell>
            <Table.HeaderCell>{t("cruise_secondPart")}<br></br><br></br></Table.HeaderCell>
            <Table.HeaderCell>{t("cruise_wait")}<br></br><br></br></Table.HeaderCell>
            <Table.HeaderCell>{t("cruise_name")}
              <br></br><br></br>
            </Table.HeaderCell>
            <Table.HeaderCell>{t("cruise_itinerary")}
              <br></br><br></br>
            </Table.HeaderCell>
            <Table.HeaderCell align="center">{t("cruise_guides")}<br></br><br></br></Table.HeaderCell>
            <Table.HeaderCell align="center">{t("cruise_languages")}<br></br><br></br></Table.HeaderCell>
          </Table.Row>
        </Table.Header>
        <Table.Body align="center">
          {cruises.map((cruise) => (
            <Table.Row key={cruise.id}>
              <Table.Cell style={{ fontSize: "14px" }}>
                <Link to={`/cruises/${cruise.id}/cruise-detail`}>
                  <b>{cruise.code}</b>
                </Link>
              </Table.Cell>
              <Table.Cell style={{ backgroundColor: cruise.yacht_color, fontSize: "11px" }}>{cruise.yacht_name}</Table.Cell>
              <Table.Cell style={{ fontSize: "11px" }}>{cruise.start_date}</Table.Cell>
              <Table.Cell style={{ fontSize: "11px" }}>{cruise.end_date}</Table.Cell>
              <Table.Cell
                align="center"
                style={{ backgroundColor: "#FBD75C", fontSize: "11px" }}
              >
                {cruise.TO}
              </Table.Cell>
              <Table.Cell
                align="center"
                style={{ backgroundColor: "#47D6DB", fontSize: "11px" }}
              >
                {cruise.PP}
              </Table.Cell>
              <Table.Cell
                align="center"
                style={{ backgroundColor: "#DBADFF", fontSize: "11px" }}
              >
                {cruise.SP}
              </Table.Cell>
              <Table.Cell
                align="center"
                style={{ backgroundColor: "#7AE7BF", fontSize: "11px" }}
              >
                {cruise.ESP}
              </Table.Cell>
              <Table.Cell style={{ fontSize: "11px" }}>{cruise.name}</Table.Cell>
              <Table.Cell style={{ fontSize: "11px" }}>{cruise.itinerary_name}</Table.Cell>
              <Table.Cell align="center" style={{ fontSize: "11px" }}>
                {cruise.guides?.map((guide) => (
                  <div>{guide}</div>
                ))}
              </Table.Cell>
              <Table.Cell align="center" style={{ fontSize: "11px" }}>
                {cruise.languages?.map((language) => (
                  <div>{t(language)}</div>
                ))}
              </Table.Cell>
            </Table.Row>
          ))}
        </Table.Body>
      </Table>
    </>
  );
}
